// extracted by mini-css-extract-plugin
export var active = "_76-a";
export var activeIndicator = "_76-9";
export var disabled = "_76-b";
export var fullWidth = "_76-2";
export var lg = "_76-7";
export var md = "_76-6";
export var redoButtonTabGroup = "_76-0";
export var sm = "_76-5";
export var tabButton = "_76-4";
export var tabButtonsContainer = "_76-1";
export var themeDestructive = "_76-d";
export var themeNormal = "_76-c";
export var themeSuccess = "_76-e";
export var xl = "_76-8";
export var xs = "_76-3";